export const cn = (...c) => c.filter(Boolean).join(" ");

export const sevClass = (sev) => ({
  critical: "sev-critical",
  high: "sev-high",
  medium: "sev-medium",
  low: "sev-low",
  info: "sev-info",
})[sev] || "sev-info";

export const sevBg = (sev) => ({
  critical: "bg-sev-critical",
  high: "bg-sev-high",
  medium: "bg-sev-medium",
  low: "bg-sev-low",
  info: "bg-sev-info",
})[sev] || "bg-sev-info";

export const letterColor = (letter) => ({
  A: "text-sev-low",       // cyan
  B: "text-primary",       // blue
  C: "text-sev-medium",
  D: "text-sev-high",
  F: "text-sev-critical",
})[letter] || "text-foreground";

export const trendIcon = (t) => (t === "up" ? "↑" : t === "down" ? "↓" : "→");

export const humanCategory = (c) =>
  c?.split("_").map(w => w[0].toUpperCase() + w.slice(1)).join(" ");

/**
 * riskTone — for numeric rating scores (0–100, higher = better).
 * Returns tailwind text class + brand hex so it can style text or Recharts fills.
 */
export const scoreTone = (score) => {
  if (score >= 90) return { text: "text-sev-low",       hex: "#00E5FF" };
  if (score >= 70) return { text: "text-primary",       hex: "#3B82F6" };
  if (score >= 50) return { text: "text-sev-medium",    hex: "#F1D302" };
  return                { text: "text-sev-critical",   hex: "#FF2E93" };
};

/**
 * riskTone — for aggregate portfolio risk (0–100, higher = worse).
 * Uses inverted thresholds so a low risk score = green, high risk score = pink.
 */
export const riskTone = (risk) => {
  if (risk >= 80) return { text: "text-sev-critical", hex: "#FF2E93", label: "Critical" };
  if (risk >= 60) return { text: "text-sev-high",     hex: "#FF6B00", label: "High"     };
  if (risk >= 40) return { text: "text-sev-medium",   hex: "#F1D302", label: "Medium"   };
  if (risk >= 20) return { text: "text-primary",      hex: "#3B82F6", label: "Low"      };
  return                { text: "text-sev-low",      hex: "#00E5FF", label: "Minimal"  };
};

/**
 * complianceStatusTone — for compliance control status labels.
 */
export const complianceStatusTone = (status) => ({
  critical:  { text: "text-sev-critical", bg: "bg-sev-critical/10", border: "border-sev-critical/40", label: "Critical gap" },
  high:      { text: "text-sev-high",     bg: "bg-sev-high/10",     border: "border-sev-high/40",     label: "High gap"     },
  attention: { text: "text-sev-medium",   bg: "bg-sev-medium/10",   border: "border-sev-medium/40",   label: "Attention"    },
  watch:     { text: "text-primary",      bg: "bg-primary/10",      border: "border-primary/40",      label: "Watch"        },
  clean:     { text: "text-sev-low",      bg: "bg-sev-low/10",      border: "border-sev-low/40",      label: "Clean"        },
})[status] || { text: "text-muted-foreground", bg: "bg-muted", border: "border-border", label: status };

/**
 * ensLevelTone — pill styling for ENS RD 311/2022 system categories.
 */
export const ensLevelTone = (level) => ({
  basico: { text: "text-primary",       border: "border-primary/60",       bg: "bg-primary/10",       label: "BÁSICO" },
  medio:  { text: "text-sev-medium",    border: "border-sev-medium/60",    bg: "bg-sev-medium/10",    label: "MEDIO"  },
  alto:   { text: "text-sev-critical",  border: "border-sev-critical/60",  bg: "bg-sev-critical/10",  label: "ALTO"   },
})[level] || { text: "text-muted-foreground", border: "border-border", bg: "bg-muted", label: (level || "").toUpperCase() };
